import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { createCardLoader } from '../cards';
import { driversLoader } from './drivers-loader';

export const driversRoutes: RouteObject = {
  loader: driversLoader,
  children: [
    {
      path: '/drivers',
      lazy: lazyComponent(
        () => import('@pages/client/driver/drivers-page'),
        'DriversPage',
      ),
    },
    {
      path: '/drivers/:driverId',
      lazy: lazyComponent(() => import('@pages/client/driver/driver-page'), 'DriverPage'),
    },
    {
      path: '/drivers/:driverId/cards/new',
      loader: createCardLoader,
      lazy: lazyComponent(
        () => import('@pages/client/driver/create-driver-card-page'),
        'CreateDriverCardPage',
      ),
    },
    {
      path: '/drivers/import',
      lazy: lazyComponent(
        () => import('@pages/client/driver/driver-import-page'),
        'DriverImportPage',
      ),
    },
  ],
};
